module.exports = {
  organizer: 'Organizer',
  home: 'Home',
  meeting: 'Meeting',
  agenda: 'Agenda',
  Sponsorship_exhibitors: 'Sponsorship & Exhibitors',
  why_sponsor: 'Why sponsor?',
  why_sponsor_text: 'SOLDOUT is a high-end business and social brand that has long focused on retail development and innovation in the Asia Pacific and China regions. Through a series of summits and exhibitions, it continues to influence and empower retail enterprises, gaining insights into new retail trends',
  enroll: 'Enroll',
  conference_pass: 'Conference pass',
  free_tickets: 'Free tickets',
  join_in_now: 'Join in now',
  new_inspiration: 'SMART RETAIL',
  new_inspiration_text: "The SMART RETAIL Summit focuses on digital transformation and supply chain innovation. Gathering over 100 Chinese and international brands and more than 300 industry leaders, it adopts an agenda integrating policy guidance, technological empowerment and practical case studies. It provides two-way enablement for localization of overseas expansion and globalization of in-China operations, driving the industry’s resilient growth and value symbiosis.",
  series_spearker: 'Series Speakers',
  speakers1: 'Hongbin Yang',
  speakers1_text1: 'VP & GM of Cryogenic Division',
  speakers1_text2: 'managing director',
  speakers1_text3: 'junlebao',
  speakers2: 'YongQiang Zheng',
  speakers2_text1: 'XWAY Brand Partner',
  speakers2_text2: 'Fosun Group',
  speakers3: 'Tao Zhang',
  speakers3_text1: 'GM of ITC',
  speakers3_text2: 'Red Star Macalline Home Group',
  speakers4: 'Yanyan Liu',
  speakers4_text1: 'VGM of Cryogenic Division',
  speakers4_text2: 'Junlebao',
  speakers5: 'Zhihua Chen',
  speakers5_text1: 'VGM',
  speakers5_text2: 'Hangzhou Wahaha Electronic Commerce Co., Ltd.',
  speakers6: 'XinWei Ye',
  speakers6_text1: 'SVP, Marketing & Technology,Greater China',
  speakers6_text2: 'Accor Group',
  speakers7: 'Jack Wu',
  speakers7_text1: 'Accor Group',
  speakers7_text2: 'k11',
  speakers8: 'Jie Deng',
  speakers8_text1: 'Director of Business Planning and Operations,Greater China',
  speakers8_text2: 'The North Face',
  speakers9: 'Aretha Chen',
  speakers9_text1: 'Director of Purchasing',
  speakers9_text2: 'Dr. Martin',
  speakers10: 'Li Xu',
  speakers10_text1: 'Director of Greater China IT',
  speakers10_text2: 'Oriflame',
  speakers11: 'Weiqin Lv',
  speakers11_text1: 'Director of New Retail',
  speakers11_text2: 'Zhongqiao Sports',
  speakers12: 'Jingru Huang',
  speakers12_text1: 'Director of New Retail at Balabala',
  speakers12_text2: 'Semir',
  speakers13: 'Xiao Liang',
  speakers13_text1: 'Director of E-Commerce Center',
  speakers13_text2: 'Chow Tai Fook',
  speakers14: 'Shaohong Chen',
  speakers14_text1: 'GM of Marketing',
  speakers14_text2: 'Elemi Group',
  speakers15: 'Xiaolu Wu',
  speakers15_text1: 'Director of Marketing & Consumer Insights',
  speakers15_text2: 'IKEA China',
  speakers16: 'Sihan Guo',
  speakers16_text1: 'VGM',
  speakers16_text2: 'Lele Cha',
  speakers17: 'Shurui Huang',
  speakers17_text1: 'Chief Brand Officer',
  speakers17_text2: 'Old Gold Mill Square',
  speakers18: 'Jia zeng',
  speakers18_text1: 'Chief Brand Office',
  speakers18_text2: 'Shengyuan International',
  speakers19: 'Chunhui HU',
  speakers19_text1: 'GM of ID',
  speakers19_text2: 'Aegean Group',
  speakers20: 'Weixuan Xu',
  speakers20_text1: 'CEO',
  speakers20_text2: 'CFB Group',
  nine_img1: 'Frontline observation',
  nine_img2: 'Intention Collection',
  nine_img3: 'Directional invitation',
  nine_img4: 'Closed door communication',
  nine_img5: 'Case presentation',
  nine_img6: 'Business referrals',
  nine_img7: 'Post meeting follow-up',
  nine_img8: 'Continuous refinement',
  nine_img9: 'Technology Show',
  sponsor: 'sponsor',
  footer1: 'New2024',
  footer2: 'Contact Us',
  footer3: 'Address: Building 1901-1902, Guosheng Center, 388 Zhongjiang Road, Putuo District, Shanghai',
  footer4: 'email：mk@huiyuexpo.com',
  footer5: 'About us',
  footer6: 'About Sponsor',
  footer7: 'About SoldOut',
  footer8: 'Series of activities',
  footer9: 'participate in',
  footer10: 'Free attendance',
  footer11: 'Participants',
  footer12: 'Speakers',
  footer13: 'Sponsorship support',
  footer14: 'Media cooperation',
  why_speech: 'Why speech',
  why_speech_text: 'SOLDOUT series summits sincerely welcome retail experts to join as keynote speakers, roundtable discussion guests, or conference hosts. If you are interested in joining the high-end retail social circle, please fill out the following application form, which will be subject to the review results of the SOLDOUT organizing committee. The review usually takes one to two working days.',
  apply_speech: 'Applying',
  speech_item1: 'Closed door case analysis and presentation',
  speech_item2: 'Attracting retail project partners',
  speech_item3: 'Improve project credibility and visibility',
  speech_item4: 'Expand retail senior network',
  speech_item5: 'Accelerate strategic deployment and market layout',
  speech_item6: 'Consolidate your industry position',
  day1: 'July 20, 2023 first day',
  day1_1: 'opening remarks',
  day1_2: 'Keynote Speech: The Core Drivers of Retail Differentiation Development',
  day1_3: 'Keynote Speech: "Beauty Economy" Soft Competitiveness, Exploring New Consumption Opportunities in the Metaverse Era',
  day1_4: 'Keynote speech: digital channel innovation leads brand renaissance and creates a new consumption pattern of Chinese Baijiu',
  day1_5: 'Morning tea break, booth visit to technology shows, interactive exchanges',
  day1_6: 'Keynote speech: Caring for users and operating as a trusted economic user',
  day1_7: 'Sponsorship Opportunities',
  day1_8: 'Round table discussion: connecting and optimizing new retail across the entire chain to achieve an overall improvement of "quality efficiency sales integration"',
  day1_9: 'lunchtime',
  day1_10: 'Keynote speech: How does the sports industry seize the opportunity in the DTC2.0 era?',
  day1_11: 'Sponsorship Opportunities',
  day1_12: 'Keynote speech: Accelerating the layout of digital intelligence and reconstructing the entire retail chain',
  day1_13: 'Keynote speech: Exploring "Digital Intelligence Integration" and Leading Innovation in Category Growth Models',
  day1_14: 'Afternoon tea break, booth visit to technology shows, interactive exchanges',
  day1_15: 'Round Table Discussion: How Brands Utilize Retail and Marketing Technologies to Upgrade and Expand in the New Consumer Era',
  day1_16: 'Closing of the meeting',
  day2: 'July 21, 2023 the next day',
  day2_1: 'opening remarks',
  day2_2: 'Keynote speech: Focusing on consumers and achieving long-term value creation',
  day2_3: 'Keynote speech: Dual empowerment of brand channels, accelerating the layout of the healthy snack market',
  day2_4: 'Keynote speech: Consumer New World, Self Innovation Permeating into the New Generation Group',
  day2_5: 'Morning tea break, booth visit to technology shows, interactive exchanges',
  day2_6: 'Keynote speech: Real time retail, opening up the "fresh" moment of smart e-commerce',
  day2_7: 'Sponsorship Opportunities',
  day2_8: 'Round table discussion: Digital transformation of physical retail and opening of smart stores',
  day2_9: 'lunchtime',
  day2_10: 'Keynote speech: Innovative marketing to create the kingdom of Haolilai pastry',
  day2_11: 'Sponsorship Opportunities',
  day2_12: 'Keynote speech: Digital technology empowers the sustainable development of the entire industry chain and brand',
  day2_13: 'Keynote speech: In the era of stock competition, brand differentiation marketing',
  day2_14: 'Afternoon tea break, booth visit to technology shows, interactive exchanges',
  day2_15: 'Round Table Discussion: How New Brands Build Core Competitiveness and Seize User Minds',
  day2_16: 'Closing of the meeting',
  sponsorship_consultation: 'Consultation',
  soldout_equity1: 'SOLDOUT sponsorship benefits include:',
  soldout_equity2: 'Closed door high-level meeting',
  soldout_equity3: 'Speech sharing',
  soldout_equity4: 'round table',
  soldout_equity5: 'Comprehensive conference promotion and promotion',
  soldout_equity6: 'Targeted invitation to potential customers before the meeting',
  soldout_equity7: 'Closed door project communication',
  soldout_equity8: 'One on one business referral',
  receive: 'You will receive',
  receive1: 'Promote new technologies and cases',
  receive2: 'Attracting new customers and collaborations',
  receive3: 'Enhance brand awareness and influence',
  receive4: 'Expand potential customer senior network',
  receive5: 'Accelerate market expansion and customer conversion',
  receive6: 'Consolidate industry position and market share',
  sponsorship_opportunities_include: 'Sponsorship opportunities include',
  opportunity1: 'High rise closed doors',
  opportunity2: 'keynote speech',
  opportunity3: 'round table',
  opportunity4: 'Exhibition booth display',
  opportunity5: 'Technology Show',
  opportunity6: 'advertising',
  tab1_1: 'Free attendance',
  tab1_2: '0￥/person',
  tab1_3: 'Free registration',
  tab1_4: 'Expire until July 1st',
  tab1_5: 'Conference of 1 Day',
  tab1_6: 'Techshow',
  tab1_7: 'Exhibition Visiting',
  tab1_8: 'Coffee Break Networking',
  tab1_9: 'Free Registration and Sign-In Passage',
  tab1_10: 'Electronic Conference Brochure',
  tab1_11: 'Five-Star Buffet Lunch',
  tab1_12: 'Simultaneous Interpretation',
  tab1_13: 'In accordance with conference arrangements',
  tab1_14: 'Publishable PowerPoint Materials',
  tab1_15: 'Business Introduction',
  tab1_16: 'Closed-Door Communication',
  tab1_17: 'Exclusive WeChat Communication Group',
  tab1_18: 'Post-Conference Recommendation',
  tab2_1: 'VIP Delegates',
  tab2_2: '3800￥/person',
  tab2_3: '4800￥/person',
  tab2_4: 'Register now',
  tab2_5: 'Expire until July 1st',
  tab2_6: 'Conference of 1 Day',
  tab2_7: 'Exhibition Visiting',
  tab2_8: 'Tea break communication',
  tab2_9: 'Exclusive registration and check-in channels',
  tab2_10: 'Paper conference journals',
  tab2_11: 'Tea break pastry',
  tab2_12: 'Exclusive Meeting Badge',
  tab2_13: 'Exclusive seats and seats',
  tab2_14: 'Exclusive Meeting Badge',
  tab2_15: 'Five Star Buffet Lunch',
  tab2_16: 'simultaneous interpretation',
  tab2_17: 'Full set of PPTs can be released after the meeting',
  tab2_18: 'Arrange according to the actual situation of the conference',
  tab2_19: 'One on one business referral',
  tab2_20: 'High level closed door communication',
  tab2_21: 'SVIP exclusive communication group',
  tab2_22: 'Post meeting referral',
  tab3_1: 'SVIP Delegates',
  tab3_2: '3800￥/person',
  tab3_3: '6800￥/person',
  tab3_4: 'Register now',
  tab3_5: 'Expire until July 1st',
  tab3_6: 'Conference of 1 Day',
  tab3_7: 'Exhibition Visiting',
  tab3_8: 'Tea break communication',
  tab3_9: 'Exclusive registration and check-in channels',
  tab3_10: 'Paper conference journals',
  tab3_11: 'Tea break pastry',
  tab3_12: 'Exclusive Meeting Badge',
  tab3_13: 'Exclusive seats and seats',
  tab3_14: 'Exclusive Meeting Badge',
  tab3_15: 'Five Star Buffet Lunch',
  tab3_16: 'simultaneous interpretation',
  tab3_17: 'Full set of PPTs can be released after the meeting',
  tab3_18: 'Arrange according to the actual situation of the conference',
  tab3_19: 'One on one business referral',
  tab3_20: 'High level closed door communication',
  tab3_21: 'SVIP exclusive communication group',
  tab3_22: 'Post meeting referral',
  term_of_service: 'Term of service',
  term1: 'cancellation',
  term1_text: 'This meeting does not accept refunds for conference tickets.',
  term2: 'replace',
  term2_text: 'The conference pass can be transferred to other colleagues within the same company, or you can transfer to other SoldOut series activities for participation within one year. If you need to replace, please notify the organizing committee at least working days in advance so that we can synchronize the registration system in real-time, making it convenient for you or relevant replacement colleagues to quickly attend and sign in. If there is no prior notice and attendance, the replacement rights cannot be enjoyed.',
  term3: 'note',
  term3_text: 'The spokesperson and agenda are updated in real-time. If some of the guest speakers in the speech collection are temporarily cancelled, we will actively seek replacements of the same level or influence. If the conference is cancelled for any reason, the responsibility of the organizing committee is limited to refunding the registration fee for the conference pass. You acknowledge that you are aware that there are no additional conditions and authorize the organizer to shoot and record audio, video, and image materials that may include you on the day of the meeting, and that they can be used for the promotion and promotion of the SoldOut series activities in the future.',
  term_of_register: 'Registration provisions'
}